export const RadioItem = ({ active, inactive, children, onClick }) => {
  return <>
    <div className={active ? "x_choose_menu_but active" : inactive ? 'x_choose_menu_but inactive' : 'x_choose_menu_but'}
      onClick={() => onClick()}
    >
      {children}
    </div>
  </>
}
